import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgEqualsIconSecondary from './svgs/EqualsIconSecondary.js';
import SvgEqualsIcon from './svgs/EqualsIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var equalsIcon = (props => useIcon(SvgEqualsIcon, SvgEqualsIconSecondary, props));

export { equalsIcon as default };
